import CanceledPayment from './CanceledPayment';

export default CanceledPayment;
